// Pure display formatting for the version-history list — row labels the user
// can actually read. All time-based helpers take an injectable `now` so they're
// deterministic under test.

/** Absolute timestamp for the row tooltip, e.g. "Aug 3, 2026, 2:14 PM". */
export function fullTimestamp(tsSeconds: number): string {
  return new Date(tsSeconds * 1000).toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

/** Coarse "time ago" for a snapshot: "just now", "5 min ago", "2 hours ago",
 *  "3 days ago", else the calendar date. */
export function relativeTime(tsSeconds: number, now: number = Date.now()): string {
  const sec = Math.round((now - tsSeconds * 1000) / 1000);
  if (sec < 45) return "just now";
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hour${hr === 1 ? "" : "s"} ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day} day${day === 1 ? "" : "s"} ago`;
  return new Date(tsSeconds * 1000).toLocaleDateString(undefined, { dateStyle: "medium" });
}

/** Net size change of a version vs the previous (older) one, for the row's
 *  "+120 B / −40 B" badge. `null` for the oldest version (no predecessor). */
export function sizeDelta(
  sizeBytes: number,
  prevSizeBytes: number | undefined,
): { delta: number; label: string } | null {
  if (prevSizeBytes === undefined) return null;
  const delta = sizeBytes - prevSizeBytes;
  if (delta === 0) return { delta: 0, label: "no change" };
  return { delta, label: `${delta > 0 ? "+" : "−"}${Math.abs(delta)} B` };
}
